'use strict';

(() => {
  if (document.querySelectorAll('.js-modal').length > 0) {
    document.querySelectorAll('.js-modal').forEach(function (current) {
      window.modal.alexModal(current);
    });
  }
})();
